import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

interface PublicStats {
  member_count: number;
  chapter_count: number;
  active_projects: number;
}

const fetchStats = async (): Promise<PublicStats> => {
  const { data, error } = await supabase.rpc("get_public_stats");
  if (error) throw error;
  return data as unknown as PublicStats;
};

export const usePublicStats = () => {
  const { data, isLoading: loading, error } = useQuery({
    queryKey: ["public-stats"],
    queryFn: fetchStats,
    staleTime: 5 * 60 * 1000,
  });

  return {
    memberCount: data?.member_count ?? 0,
    chapterCount: data?.chapter_count ?? 0,
    activeProjects: data?.active_projects ?? 0,
    loading,
    error: error as Error | null,
  };
};
